/* eslint-disable react/jsx-closing-tag-location, no-nested-ternary, object-property-newline, react/jsx-one-expression-per-line, operator-linebreak, indent */
/** Farm — dala tafsiloti (web S3): summary + 4 tab + xarita (ko'rish). */
import React, { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import Layout from '../../components/Layout'
import Loader from '../../components/common/Loader'
import FarmModal from './FarmModal'
import FieldMap from './FieldMap'
import { farmRequest, fmtMoney, fmtNum, useFarmList, useFarmLoad } from './api'

const TABS = ['Amaliyotlar', 'Moliya', 'Hosil', 'Eslatmalar']

export default function FarmFieldDetail() {
    const { id } = useParams()
    const [season, setSeason] = useState('current')
    const [tab, setTab] = useState(0)
    // modal: null | 'season' | 'compare' | {kind:'operation'|'harvest', item?}
    const [modal, setModal] = useState(null)
    const summary = useFarmLoad(`fields/${id}/summary/`, { season }, [id, season])
    const s = summary.data

    const modalKind = modal && typeof modal === 'object' ? modal.kind : modal
    const modalItem = modal && typeof modal === 'object' ? modal.item : null

    async function removeRecord(url, what) {
        // eslint-disable-next-line no-alert
        if (!window.confirm(`${what} o‘chirilsinmi? Bog‘liq avto-tranzaksiya ham o‘chadi.`)) return
        await farmRequest({ url, method: 'DELETE' })
        summary.reload()
    }

    return (
        <Layout>
            <nav className="breadcrumb mb-3" aria-label="breadcrumbs">
                <ul>
                    <li><Link to="/farm">Dala boshqaruvi</Link></li>
                    <li className="is-active"><a href="#!">{s ? s.field.name : '...'}</a></li>
                </ul>
            </nav>

            {summary.loading && !s ? <Loader center large /> : null}
            {s && (
                <>
                    <div className="is-flex is-justify-content-space-between is-align-items-center mb-3 is-flex-wrap-wrap" style={{ gap: 12 }}>
                        <div>
                            <h1 className="title is-4 mb-1">{s.field.name}</h1>
                            <p className="has-text-grey">
                                {s.field.category} · {fmtNum(s.field.areaHa, 2)} ga
                            </p>
                        </div>
                        <div className="is-flex is-align-items-center" style={{ gap: 8 }}>
                            {s.seasons.length > 0 && (
                                <div className="select">
                                    <select
                                        value={s.season ? s.season.id : ''}
                                        onChange={(e) => setSeason(e.target.value)}>
                                        {s.seasons.map((sn) => (
                                            <option key={sn.id} value={sn.id}>
                                                {sn.year} — {sn.crop}{sn.isActive ? ' (faol)' : ''}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            <button type="button" className="button is-light"
                                onClick={() => setModal('season')}>
                                + Mavsum
                            </button>
                            {s.seasons.length >= 2 && (
                                <button type="button" className="button is-light"
                                    onClick={() => setModal('compare')}>
                                    <i className="icon ion-md-git-compare mr-1" /> Taqqoslash
                                </button>
                            )}
                        </div>
                    </div>

                    {s.field.boundary && (
                        <div className="box p-2 mb-4">
                            <FieldMap boundary={s.field.boundary} />
                        </div>
                    )}

                    <div className="tabs is-boxed mb-0">
                        <ul>
                            {TABS.map((t, i) => (
                                <li key={t} className={i === tab ? 'is-active' : ''}>
                                    <a href="#!" onClick={(e) => { e.preventDefault(); setTab(i) }}>{t}</a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="box" style={{ borderTopLeftRadius: 0 }}>
                        {!s.season && tab !== 3 ? (
                            <p className="has-text-grey has-text-centered py-5">
                                Mavsum yo‘q — «+ Mavsum» bilan qo‘shing.
                            </p>
                        ) : (
                            <>
                                {tab === 0 && (
                                    <OperationsTab s={s}
                                        onAdd={() => setModal({ kind: 'operation' })}
                                        onEdit={(op) => setModal({ kind: 'operation', item: op })}
                                        onDelete={(op) => removeRecord(`operations/${op.id}/`, 'Amaliyot')} />
                                )}
                                {tab === 1 && <FinanceTab s={s} reload={summary.reload} />}
                                {tab === 2 && (
                                    <HarvestTab s={s}
                                        onAdd={() => setModal({ kind: 'harvest' })}
                                        onEdit={(h) => setModal({ kind: 'harvest', item: h })}
                                        onDelete={(h) => removeRecord(`harvests/${h.id}/`, 'Hosil yozuvi')} />
                                )}
                            </>
                        )}
                        {tab === 3 && <NotesTab fieldId={id} />}
                    </div>

                    <OperationModal
                        key={modalKind === 'operation' ? `op-${modalItem ? modalItem.id : 'new'}` : 'op-closed'}
                        isOpen={modalKind === 'operation'} seasonId={s.season && s.season.id}
                        existing={modalItem}
                        onClose={() => setModal(null)}
                        onSaved={() => { setModal(null); summary.reload() }} />
                    <HarvestModal
                        key={modalKind === 'harvest' ? `h-${modalItem ? modalItem.id : 'new'}` : 'h-closed'}
                        isOpen={modalKind === 'harvest'} seasonId={s.season && s.season.id}
                        existing={modalItem}
                        crop={s.season ? s.season.crop : ''}
                        onClose={() => setModal(null)}
                        onSaved={() => { setModal(null); summary.reload() }} />
                    <SeasonModal isOpen={modal === 'season'} fieldId={id}
                        onClose={() => setModal(null)}
                        onSaved={() => { setModal(null); setSeason('current'); summary.reload() }} />
                    {modal === 'compare' && (
                        <CompareModal fieldId={id} seasons={s.seasons}
                            onClose={() => setModal(null)} />
                    )}
                </>
            )}
        </Layout>
    )
}

// ==================== Tab 1: Amaliyotlar ====================

function OperationsTab({ s, onAdd, onEdit, onDelete }) {
    const ops = s.operations
    if (!ops) return null
    return (
        <>
            <div className="is-flex is-justify-content-space-between is-align-items-center mb-3 is-flex-wrap-wrap" style={{ gap: 8 }}>
                <div className="tags mb-0">
                    {ops.lastIrrigation && <span className="tag is-info is-light">Oxirgi sug‘orish: {ops.lastIrrigation}</span>}
                    {ops.lastFertilizing && <span className="tag is-success is-light">Oxirgi o‘g‘itlash: {ops.lastFertilizing}</span>}
                    <span className="tag">Jami: {ops.count} ta</span>
                </div>
                <button type="button" className="button is-link is-small" onClick={onAdd}>
                    + Amaliyot
                </button>
            </div>
            <table className="table is-fullwidth is-striped">
                <thead>
                    <tr>
                        <th>Sana</th><th>Turi</th><th>Material</th>
                        <th className="has-text-right">Miqdor</th>
                        <th className="has-text-right">Xarajat (so‘m)</th><th>Izoh</th>
                        <th style={{ width: 90 }} />
                    </tr>
                </thead>
                <tbody>
                    {(ops.recent || []).map((op) => (
                        <tr key={op.id}>
                            <td>{op.date}</td>
                            <td><b>{op.operationTypeName}</b></td>
                            <td>{op.materialName || '—'}</td>
                            <td className="has-text-right">
                                {op.quantity ? `${fmtNum(op.quantity)} ${op.unitName || ''}` : '—'}
                            </td>
                            <td className="has-text-right">{Number(op.cost) > 0 ? fmtMoney(op.cost) : '—'}</td>
                            <td className="has-text-grey is-size-7">{op.note}</td>
                            <td className="has-text-right">
                                <button type="button" className="button is-small is-white mr-1"
                                    title="Tahrirlash" onClick={() => onEdit(op)}>
                                    <i className="icon ion-md-create" />
                                </button>
                                <button type="button" className="button is-small is-white"
                                    title="O‘chirish" onClick={() => onDelete(op)}>
                                    <i className="icon ion-md-trash has-text-danger" />
                                </button>
                            </td>
                        </tr>
                    ))}
                    {(ops.recent || []).length === 0 && (
                        <tr><td colSpan={7} className="has-text-centered has-text-grey py-4">
                            Amaliyot yozuvlari yo‘q.
                        </td></tr>
                    )}
                </tbody>
            </table>
            {ops.count > (ops.recent || []).length && (
                <p className="has-text-grey is-size-7">Oxirgi {ops.recent.length} ta ko‘rsatildi (jami {ops.count}).</p>
            )}
        </>
    )
}

// ==================== Tab 2: Moliya ====================

function FinanceTab({ s, reload }) {
    const [showTxModal, setShowTxModal] = useState(false)
    const fin = s.finance
    if (!fin) {
        return (
            <p className="has-text-grey has-text-centered py-5">
                Moliya ma‘lumotlari sizning rolingizga ochiq emas.
            </p>
        )
    }
    const profit = Number(fin.profit)
    return (
        <>
            <div className="columns is-multiline mb-2">
                <StatCard title="Chiqim" value={`${fmtMoney(fin.totalExpense)} so‘m`} color="has-text-danger" />
                <StatCard title="Kirim" value={`${fmtMoney(fin.totalIncome)} so‘m`} color="has-text-success" />
                <StatCard title="Foyda" value={`${fmtMoney(profit)} so‘m`}
                    color={profit >= 0 ? 'has-text-success' : 'has-text-danger'} />
                <StatCard title="1 ga xarajat" value={fin.costPerHa ? `${fmtMoney(fin.costPerHa)} so‘m` : '—'} />
                <StatCard title="1 kg tannarx" value={fin.costPerKg ? `${fmtMoney(fin.costPerKg)} so‘m` : '—'} />
            </div>

            {(fin.expenseBreakdown || []).length > 0 && (
                <>
                    <h3 className="title is-6 mb-2">Xarajatlar taqsimoti</h3>
                    <table className="table is-fullwidth mb-5">
                        <tbody>
                            {fin.expenseBreakdown.map((b) => (
                                <tr key={b.label}>
                                    <td style={{ width: 180 }}>{b.label}</td>
                                    <td>
                                        <progress className="progress is-small is-warning mb-0"
                                            value={b.percent} max="100" style={{ marginTop: 6 }} />
                                    </td>
                                    <td className="has-text-right" style={{ width: 160 }}>
                                        {fmtMoney(b.amount)} <span className="has-text-grey is-size-7">({b.percent}%)</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}

            <TransactionsTable seasonId={s.season.id} s={s} onChanged={reload}
                onAddManual={() => setShowTxModal(true)} />
            <ManualTxModal key={showTxModal ? 'tx-open' : 'tx-closed'}
                isOpen={showTxModal} seasonId={s.season.id}
                onClose={() => setShowTxModal(false)}
                onSaved={() => { setShowTxModal(false); reload() }} />
        </>
    )
}

function TransactionsTable({ seasonId, s, onChanged, onAddManual }) {
    // `s` deps'da: summary yangilanganda (yangi yozuv, o'chirish) qayta yuklanadi
    const txs = useFarmList('transactions/', { season: seasonId }, [seasonId, s])

    async function removeTx(t) {
        // eslint-disable-next-line no-alert
        if (!window.confirm('Tranzaksiya o‘chirilsinmi?')) return
        await farmRequest({ url: `transactions/${t.id}/`, method: 'DELETE' })
        onChanged()
    }

    return (
        <>
            <div className="is-flex is-justify-content-space-between is-align-items-center mb-2">
                <h3 className="title is-6 mb-0">Tranzaksiyalar</h3>
                <button type="button" className="button is-small is-link is-light"
                    onClick={onAddManual}>
                    + Qo‘lda tranzaksiya (ijara, boshqa)
                </button>
            </div>
            {txs.loading ? <Loader center /> : (
                <table className="table is-fullwidth is-striped">
                    <thead>
                        <tr><th>Sana</th><th>Kategoriya</th><th>Turi</th>
                            <th className="has-text-right">Summa (so‘m)</th><th /></tr>
                    </thead>
                    <tbody>
                        {txs.items.map((t) => (
                            <tr key={t.id}>
                                <td>{t.date}</td>
                                <td>{t.categoryLabel || '—'}
                                    {t.isAuto && <span className="tag is-light is-small ml-1">avto</span>}</td>
                                <td>{t.type === 'income'
                                    ? <span className="has-text-success">kirim</span>
                                    : <span className="has-text-danger">chiqim</span>}</td>
                                <td className="has-text-right">
                                    {t.type === 'income' ? '+' : '−'}{fmtMoney(t.amount)}
                                </td>
                                <td className="has-text-right" style={{ width: 50 }}>
                                    {!t.isAuto && (
                                        <button type="button" className="button is-small is-white"
                                            title="O‘chirish" onClick={() => removeTx(t)}>
                                            <i className="icon ion-md-trash has-text-danger" />
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                        {txs.items.length === 0 && (
                            <tr><td colSpan={5} className="has-text-centered has-text-grey py-4">
                                Tranzaksiyalar yo‘q.
                            </td></tr>
                        )}
                    </tbody>
                </table>
            )}
        </>
    )
}

// ==================== Tab 3: Hosil ====================

function HarvestTab({ s, onAdd, onEdit, onDelete }) {
    const h = s.harvest
    if (!h) return null
    return (
        <>
            <div className="is-flex is-justify-content-space-between is-align-items-center mb-3">
                <div className="tags mb-0">
                    <span className="tag is-success is-light">Jami: {fmtNum(h.totalQuantityKg, 0)} kg</span>
                    {h.yieldPerHa != null && (
                        <span className="tag">Hosildorlik: {fmtNum(h.yieldPerHa, 0)} kg/ga</span>
                    )}
                </div>
                <button type="button" className="button is-link is-small" onClick={onAdd}>
                    + Hosil
                </button>
            </div>
            <table className="table is-fullwidth is-striped">
                <thead>
                    <tr><th>Sana</th><th>Mahsulot</th>
                        <th className="has-text-right">Miqdor</th>
                        <th className="has-text-right">Narx</th>
                        <th className="has-text-right">Jami kirim (so‘m)</th>
                        <th style={{ width: 90 }} /></tr>
                </thead>
                <tbody>
                    {(h.entries || []).map((e) => (
                        <tr key={e.id}>
                            <td>{e.date}</td>
                            <td><b>{e.product}</b></td>
                            <td className="has-text-right">{fmtNum(e.quantity, 0)} {e.unitName || 'kg'}</td>
                            <td className="has-text-right">{e.unitPrice ? fmtMoney(e.unitPrice) : '—'}</td>
                            <td className="has-text-right">
                                {e.totalIncome
                                    ? <span className="has-text-success">+{fmtMoney(e.totalIncome)}</span>
                                    : <span className="tag is-light">sotilmagan</span>}
                            </td>
                            <td className="has-text-right">
                                <button type="button" className="button is-small is-white mr-1"
                                    title="Tahrirlash" onClick={() => onEdit(e)}>
                                    <i className="icon ion-md-create" />
                                </button>
                                <button type="button" className="button is-small is-white"
                                    title="O‘chirish" onClick={() => onDelete(e)}>
                                    <i className="icon ion-md-trash has-text-danger" />
                                </button>
                            </td>
                        </tr>
                    ))}
                    {(h.entries || []).length === 0 && (
                        <tr><td colSpan={6} className="has-text-centered has-text-grey py-4">
                            Hosil yozuvlari yo‘q.
                        </td></tr>
                    )}
                </tbody>
            </table>
        </>
    )
}

// ==================== Tab 4: Eslatmalar ====================

function NotesTab({ fieldId }) {
    const notes = useFarmList('scout-notes/', { field: fieldId }, [fieldId])
    if (notes.loading) return <Loader center />
    if (notes.items.length === 0) {
        return (
            <p className="has-text-grey has-text-centered py-5">
                Kuzatuv eslatmalari yo‘q (foto+GPS eslatmalar mobil ilovada qo‘shiladi).
            </p>
        )
    }
    return (
        <div className="columns is-multiline">
            {notes.items.map((n) => (
                <div key={n.id} className="column is-3">
                    <div className="card">
                        {n.photo && (
                            <div className="card-image">
                                <figure className="image is-4by3">
                                    <img src={n.photo} alt="eslatma" style={{ objectFit: 'cover' }} />
                                </figure>
                            </div>
                        )}
                        <div className="card-content p-3">
                            <p className="is-size-7 has-text-grey mb-1">
                                {(n.date || '').replace('T', ' ').split('.')[0]}
                            </p>
                            <p className="is-size-7">{n.text || '(fotosuratli eslatma)'}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

// ==================== Modallar ====================

function StatCard({ title, value, color = '' }) {
    return (
        <div className="column is-one-fifth-desktop is-half-mobile">
            <div className="box p-3 has-background-white-ter" style={{ height: '100%' }}>
                <p className="is-size-7 has-text-grey">{title}</p>
                <p className={`is-size-6 has-text-weight-bold ${color}`}>{value}</p>
            </div>
        </div>
    )
}

function OperationModal({ isOpen, seasonId, existing, onClose, onSaved }) {
    const types = useFarmList('operation-types/', {}, [isOpen])
    const materials = useFarmList('materials/', {}, [isOpen])
    const units = useFarmList('units/', {}, [isOpen])
    const [form, setForm] = useState(existing ? {
        operationType: existing.operationType || '',
        date: existing.date,
        material: existing.material || '',
        quantity: existing.quantity || '',
        unit: existing.unit || '',
        cost: Number(existing.cost) > 0 ? existing.cost : '',
        note: existing.note || '',
    } : {
        operationType: '', date: new Date().toISOString().slice(0, 10),
        material: '', quantity: '', unit: '', cost: '', note: '',
    })
    const [saving, setSaving] = useState(false)
    const [error, setError] = useState('')
    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value })

    async function save(e) {
        e.preventDefault()
        if (!form.operationType) { setError('Amaliyot turini tanlang.'); return }
        setSaving(true)
        setError('')
        try {
            const data = {
                season: seasonId,
                operationType: form.operationType,
                date: form.date,
                material: form.material || null,
                quantity: form.quantity || null,
                unit: form.unit || null,
                cost: form.cost || '0',
                note: form.note,
            }
            await farmRequest(existing
                ? { url: `operations/${existing.id}/`, method: 'PATCH', data }
                : { url: 'operations/', method: 'POST', data })
            onSaved()
        } catch (err) {
            setError('Saqlashda xato — maydonlarni tekshiring.')
        } finally {
            setSaving(false)
        }
    }

    return (
        <FarmModal title={existing ? 'Amaliyotni tahrirlash' : 'Amaliyot qo‘shish'}
            isOpen={isOpen} onClose={onClose}>
            <form onSubmit={save}>
                <div className="field">
                    <label className="label">Turi *</label>
                    <div className="select is-fullwidth">
                        <select value={form.operationType} onChange={set('operationType')}>
                            <option value="">— tanlang —</option>
                            {types.items.filter((t) => !t.isHidden).map((t) => (
                                <option key={t.id} value={t.id}>{t.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="columns">
                    <div className="column">
                        <label className="label">Sana</label>
                        <input className="input" type="date" value={form.date} onChange={set('date')} />
                    </div>
                    <div className="column">
                        <label className="label">Material</label>
                        <div className="select is-fullwidth">
                            <select value={form.material} onChange={set('material')}>
                                <option value="">—</option>
                                {materials.items.map((m) => (
                                    <option key={m.id} value={m.id}>{m.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="columns">
                    <div className="column">
                        <label className="label">Miqdor</label>
                        <input className="input" type="number" step="0.001" min="0"
                            value={form.quantity} onChange={set('quantity')} />
                    </div>
                    <div className="column">
                        <label className="label">Birlik</label>
                        <div className="select is-fullwidth">
                            <select value={form.unit} onChange={set('unit')}>
                                <option value="">—</option>
                                {units.items.map((u) => (
                                    <option key={u.id} value={u.id}>{u.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="column">
                        <label className="label">Xarajat (so‘m)</label>
                        <input className="input" type="number" min="0"
                            value={form.cost} onChange={set('cost')} />
                    </div>
                </div>
                <div className="field">
                    <label className="label">Izoh</label>
                    <input className="input" value={form.note} onChange={set('note')} />
                </div>
                <p className="help mb-2">Xarajat kiritilsa, chiqim tranzaksiyasi avtomatik yaratiladi.</p>
                {error && <p className="has-text-danger is-size-7 mb-2">{error}</p>}
                <button type="submit" className={`button is-link is-fullwidth ${saving ? 'is-loading' : ''}`}>
                    Saqlash
                </button>
            </form>
        </FarmModal>
    )
}

function HarvestModal({ isOpen, seasonId, crop, existing, onClose, onSaved }) {
    const units = useFarmList('units/', {}, [isOpen])
    const [form, setForm] = useState(existing ? {
        product: existing.product,
        date: existing.date,
        quantity: existing.quantity || '',
        unit: existing.unit || '',
        unitPrice: existing.unitPrice || '',
    } : {
        product: crop || '', date: new Date().toISOString().slice(0, 10),
        quantity: '', unit: '', unitPrice: '',
    })
    const [saving, setSaving] = useState(false)
    const [error, setError] = useState('')
    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value })
    const preview = (Number(form.quantity) || 0) * (Number(form.unitPrice) || 0)

    async function save(e) {
        e.preventDefault()
        if (!form.product || !form.quantity) { setError('Mahsulot va miqdor majburiy.'); return }
        setSaving(true)
        setError('')
        try {
            const data = {
                season: seasonId,
                product: form.product,
                date: form.date,
                quantity: form.quantity,
                unit: form.unit || null,
                unitPrice: form.unitPrice || null,
            }
            await farmRequest(existing
                ? { url: `harvests/${existing.id}/`, method: 'PATCH', data }
                : { url: 'harvests/', method: 'POST', data })
            onSaved()
        } catch (err) {
            setError('Saqlashda xato — maydonlarni tekshiring.')
        } finally {
            setSaving(false)
        }
    }

    return (
        <FarmModal title={existing ? 'Hosilni tahrirlash' : 'Hosil qo‘shish'}
            isOpen={isOpen} onClose={onClose}>
            <form onSubmit={save}>
                <div className="columns">
                    <div className="column">
                        <label className="label">Mahsulot *</label>
                        <input className="input" value={form.product} onChange={set('product')} />
                    </div>
                    <div className="column">
                        <label className="label">Sana</label>
                        <input className="input" type="date" value={form.date} onChange={set('date')} />
                    </div>
                </div>
                <div className="columns">
                    <div className="column">
                        <label className="label">Miqdor *</label>
                        <input className="input" type="number" step="0.001" min="0"
                            value={form.quantity} onChange={set('quantity')} />
                    </div>
                    <div className="column">
                        <label className="label">Birlik</label>
                        <div className="select is-fullwidth">
                            <select value={form.unit} onChange={set('unit')}>
                                <option value="">kg</option>
                                {units.items.map((u) => (
                                    <option key={u.id} value={u.id}>{u.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="column">
                        <label className="label">Birlik narxi</label>
                        <input className="input" type="number" min="0"
                            value={form.unitPrice} onChange={set('unitPrice')} />
                    </div>
                </div>
                {preview > 0 && (
                    <p className="has-text-success mb-2">Jami kirim: {fmtMoney(preview)} so‘m</p>
                )}
                {error && <p className="has-text-danger is-size-7 mb-2">{error}</p>}
                <button type="submit" className={`button is-link is-fullwidth ${saving ? 'is-loading' : ''}`}>
                    Saqlash
                </button>
            </form>
        </FarmModal>
    )
}

function SeasonModal({ isOpen, fieldId, onClose, onSaved }) {
    const [year, setYear] = useState(new Date().getFullYear())
    const [crop, setCrop] = useState('')
    const [saving, setSaving] = useState(false)
    const [error, setError] = useState('')

    async function save(e) {
        e.preventDefault()
        if (!crop.trim()) { setError('Ekin nomini kiriting.'); return }
        setSaving(true)
        setError('')
        try {
            await farmRequest({
                url: 'seasons/',
                method: 'POST',
                data: { field: fieldId, year, crop: crop.trim(), isActive: true },
            })
            onSaved()
        } catch (err) {
            setError('Saqlashda xato.')
        } finally {
            setSaving(false)
        }
    }

    return (
        <FarmModal title="Yangi mavsum" isOpen={isOpen} onClose={onClose} width={400}>
            <form onSubmit={save}>
                <div className="field">
                    <label className="label">Yil</label>
                    <input className="input" type="number" value={year}
                        onChange={(e) => setYear(Number(e.target.value))} />
                </div>
                <div className="field">
                    <label className="label">Ekin</label>
                    <input className="input" placeholder="Masalan: Paxta" value={crop}
                        onChange={(e) => setCrop(e.target.value)} />
                </div>
                {error && <p className="has-text-danger is-size-7 mb-2">{error}</p>}
                <button type="submit" className={`button is-link is-fullwidth ${saving ? 'is-loading' : ''}`}>
                    Qo‘shish
                </button>
            </form>
        </FarmModal>
    )
}

/** Qo'lda tranzaksiya — amaliyotga bog'lanmagan kirim/chiqim (ijara va h.k.).
 * Faqat owner/hisobchi; backend brigadirga 403 qaytaradi. */
function ManualTxModal({ isOpen, seasonId, onClose, onSaved }) {
    const [form, setForm] = useState({
        type: 'expense', amount: '', date: new Date().toISOString().slice(0, 10),
        categoryLabel: '', note: '',
    })
    const [saving, setSaving] = useState(false)
    const [error, setError] = useState('')
    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value })

    async function save(e) {
        e.preventDefault()
        if (!form.amount) { setError('Summani kiriting.'); return }
        setSaving(true)
        setError('')
        try {
            await farmRequest({
                url: 'transactions/',
                method: 'POST',
                data: {
                    season: seasonId,
                    type: form.type,
                    amount: form.amount,
                    date: form.date,
                    categoryLabel: form.categoryLabel || (form.type === 'income' ? 'Boshqa kirim' : 'Boshqa chiqim'),
                    note: form.note,
                },
            })
            onSaved()
        } catch (err) {
            setError('Saqlashda xato — maydonlarni tekshiring.')
        } finally {
            setSaving(false)
        }
    }

    return (
        <FarmModal title="Qo‘lda tranzaksiya" isOpen={isOpen} onClose={onClose} width={440}>
            <form onSubmit={save}>
                <div className="field">
                    <label className="label">Turi</label>
                    <div className="buttons has-addons mb-0">
                        <button type="button"
                            className={`button ${form.type === 'expense' ? 'is-danger is-light is-active' : ''}`}
                            onClick={() => setForm({ ...form, type: 'expense' })}>Chiqim</button>
                        <button type="button"
                            className={`button ${form.type === 'income' ? 'is-success is-light is-active' : ''}`}
                            onClick={() => setForm({ ...form, type: 'income' })}>Kirim</button>
                    </div>
                </div>
                <div className="columns">
                    <div className="column">
                        <label className="label">Summa (so‘m) *</label>
                        <input className="input" type="number" min="0"
                            value={form.amount} onChange={set('amount')} />
                    </div>
                    <div className="column">
                        <label className="label">Sana</label>
                        <input className="input" type="date"
                            value={form.date} onChange={set('date')} />
                    </div>
                </div>
                <div className="field">
                    <label className="label">Kategoriya yorlig‘i</label>
                    <input className="input" placeholder="Masalan: Ijara"
                        value={form.categoryLabel} onChange={set('categoryLabel')} />
                </div>
                <div className="field">
                    <label className="label">Izoh</label>
                    <input className="input" value={form.note} onChange={set('note')} />
                </div>
                {error && <p className="has-text-danger is-size-7 mb-2">{error}</p>}
                <button type="submit" className={`button is-link is-fullwidth ${saving ? 'is-loading' : ''}`}>
                    Saqlash
                </button>
            </form>
        </FarmModal>
    )
}

/** Mavsumlarni taqqoslash — bir dala, ikki mavsum yonma-yon. */
function CompareModal({ fieldId, seasons, onClose }) {
    const [leftId, setLeftId] = useState(seasons[0] ? seasons[0].id : null)
    const [rightId, setRightId] = useState(seasons[1] ? seasons[1].id : null)
    const left = useFarmLoad(`fields/${fieldId}/summary/`, { season: leftId }, [leftId])
    const right = useFarmLoad(`fields/${fieldId}/summary/`, { season: rightId }, [rightId])

    const fin = (d, k) => {
        const v = d && d.finance && d.finance[k]
        return v == null ? null : Number(v)
    }
    const rows = [
        ['Ekin', (d) => (d.season ? d.season.crop : '—'), false],
        ['Amaliyotlar', (d) => `${(d.operations && d.operations.count) || 0} ta`, false],
        ['Chiqim', (d) => fin(d, 'totalExpense'), true],
        ['Kirim', (d) => fin(d, 'totalIncome'), true],
        ['Foyda', (d) => fin(d, 'profit'), true],
        ['1 ga xarajat', (d) => fin(d, 'costPerHa'), true],
        ['1 kg tannarx', (d) => fin(d, 'costPerKg'), true],
        ['Hosil (kg)', (d) => (d.harvest ? Number(d.harvest.totalQuantityKg) : null), true],
        ['Hosildorlik (kg/ga)', (d) => (d.harvest && d.harvest.yieldPerHa != null
            ? Number(d.harvest.yieldPerHa) : null), true],
    ]

    const loading = left.loading || right.loading

    return (
        <FarmModal title="Mavsumlarni taqqoslash" isOpen onClose={onClose} width={640}>
            <div className="columns mb-2">
                {[[leftId, setLeftId, 'A'], [rightId, setRightId, 'B']].map(([val, setVal, label]) => (
                    <div className="column" key={label}>
                        <div className="select is-fullwidth">
                            <select value={val || ''} onChange={(e) => setVal(e.target.value)}>
                                {seasons.map((sn) => (
                                    <option key={sn.id} value={sn.id}>{sn.year} — {sn.crop}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                ))}
            </div>
            {loading ? <Loader center /> : (
                <table className="table is-fullwidth is-striped">
                    <tbody>
                        {rows.map(([label, getter, isNumber]) => {
                            const a = left.data ? getter(left.data) : null
                            const b = right.data ? getter(right.data) : null
                            return (
                                <tr key={label}>
                                    <td className="has-text-grey">{label}</td>
                                    <td className="has-text-centered has-text-weight-semibold">
                                        {isNumber ? fmtMoney(a) : (a || '—')}
                                    </td>
                                    <td className="has-text-centered has-text-weight-semibold">
                                        {isNumber ? fmtMoney(b) : (b || '—')}
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            )}
        </FarmModal>
    )
}
